import { useAuth } from '@/contexts/auth-context';
import { useCallback, useState } from 'react';

/**
 * Leaving, from the locked dashboard.
 *
 * The session endpoint sits outside the dashboard, so signing out works whatever
 * the lock refuses, and the auth context already clears the local session even
 * when the call itself fails. The redirect is therefore unconditional: a
 * merchant told to log out must actually end up logged out.
 */
export function useLogoutFromLockedPage() {
  const { logout: endSession } = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const logout = useCallback(async () => {
    setIsLoggingOut(true);

    try {
      await endSession();
    } finally {
      window.location.href = '/';
    }
  }, [endSession]);

  return { logout, isLoggingOut };
}
